import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appAllGetHubs } from '../../store/hubs'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetFundrasing } from '../../store/fundrasing'
import ReceiptPDF from '../../components/filegenerate/filegenerate'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()

	const [page, setPage] = useState(params.page || 1)
	// const [showUserModal, setShowUserModal] = useState(false);
	// const [rejectionReason, setRejectionReason] = useState("");
	// const [rejectionError, setRejectionError] = useState("");
	// const [rejectedId, setRejectedId] = useState(null);
	const [error, setError] = useState('')
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	// const facilitylist = useSelector(
	//   (state) => state.facilitybookingReducer.facilitylist
	// );
	// const contribution = useSelector(
	//   (state) => state.contributionReducer.contribution
	// );
	// console.log(contribution);
	const paginate = useSelector(state => state.fundrasingReducer.paginate)
	const isloder = useSelector(state => state?.facilitybookingReducer.isloder)
	//const hub = useSelector((state) => state?.hubReducer.hub);
	//const sanstha = useSelector((state) => state?.sansthaReducer.sanstha);
	const fundrasing = useSelector(state => state?.fundrasingReducer.fundrasing)
	//	console.log('fundrasing', fundrasing)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({
		sanstha: null,
		hub: null,
		contributionType: null,
		startDate: null,
		endDate: null,
		paymentRef: '',
	})

	// useEffect(() => {
	// 	// dispatch(appAllGetFundrasing({ page: 1, limit: 10 ,sanstha: sansthaId || permissionOfSanstha}));
	// 	dispatch(appGetAllSanstha({ page: 1, limit: 1000 }))
	// 	dispatch(appAllGetHubs({ page: 1, limit: 1000 }))
	// }, [])

	useEffect(() => {
		const searchParams = {
			...activeFilters,
			page,
			limit: 10,
			sanstha: sansthaId || permissionOfSanstha,
		}
		//	console.log(searchParams)
		dispatch(appAllGetFundrasing(searchParams))
		// navigate(`/contribution/${page}`);
	}, [page, activeFilters])

	const handleSearch = useCallback(() => {
		if (selectedFilters.startDate && !selectedFilters.endDate) {
			setError('Please select an end date.')
			return
		}

		setError('')
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.contributionType) {
			filters.contributionType = selectedFilters.contributionType
		}
		if (selectedFilters.startDate) {
			filters.startDate = selectedFilters.startDate
		}
		if (selectedFilters.endDate) {
			filters.endDate = selectedFilters.endDate
		}
		if (selectedFilters.paymentRef) {
			filters.paymentRef = selectedFilters.paymentRef
		}
		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters])

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Contribution Type</label>
								<select
									className="form-control"
									name="contributionType"
									value={selectedFilters.contributionType || ''}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											contributionType: e.target.value || null,
										}))
									}}
								>
									<option value="">Select Contribution Type</option>
									<option value="Membership Subscription">Membership Subscription</option>
									<option value="Boli Contributions">Boli Contributions</option>{' '}
									<option value="Social Project Donations">Social Project Donations</option>{' '}
									<option value="Voluntary Contribution">Voluntary Contribution</option>
									<option value="Sales/Service Collections">Sales/Service Collections</option>
									<option value="Facility Booking">Facility Booking</option>
								</select>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label>Start Date</label>
								<input
									type="date"
									className="form-control"
									value={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											startDate: value,
											endDate: prev.endDate && prev.endDate < value ? '' : prev.endDate,
										}))
									}}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>End Date</label>
								<input
									type="date"
									className="form-control"
									min={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									value={selectedFilters.endDate || ''}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											endDate: value,
										}))
										if (value) {
											setError('')
										}
									}}
								/>
								{error && <span className="text-danger">{error}</span>}
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Search by Reference No</label>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Reference No"
									value={selectedFilters.paymentRef || ''}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											paymentRef: e.target.value,
										}))
									}}
								/>
							</div>
						</div>
						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										sanstha: null,
										hub: null,
										startDate: null,
										endDate: null,
										paymentRef: '',
									})
									setActiveFilters({})
									setExportFilters({})
									setPage(1)
									// dispatch(appAllGetContribution({ page: 1, limit: 10 }));
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>

						<div className="col text-right">
							<div style={{ fontSize: '18px' }}>
								Total Fundraising : ₹ {fundrasing?.totalAmount}
							</div>
						</div>
					</div>
					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Community</th>
									<th>Sanstha</th>
									<th>User</th>
									<th>Contribution Type</th>
									<th>Payment Screenshot</th>
									<th>Online/Offline</th>
									<th>Amount</th>
									<th>Payment Date</th>
									<th>Payment Reference No</th>
									{/* <th>Status</th> */}
									<th>Action</th>

									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{fundrasing?.data &&
								fundrasing?.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td>
													{value?.hub ? (
														<>
															{value?.hub?.image && <PostPreview value={value?.hub?.image} />}
															{toCamelCase(value?.hub?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													{value?.sansthaId ? (
														<>
															{value?.sansthaId?.image && (
																<PostPreview value={value?.sansthaId?.image} />
															)}

															{toCamelCase(value?.sansthaId?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													<PostPreview value={value?.userId?.profilePic} />
													{value?.userId?.firstName} {value?.userId?.lastName}
													<br />
													<small>{value?.userId?.mobile}</small>
												</td>
												<td>
													<br />
													{value?.fundraisingType}
												</td>
												<td>
													<PostPreview value={value?.paymentScreenshot} />
												</td>
												<td>
													{value?.isOnline}
													{value?.isOnline === true ? (
														<span className="badge badge-primary">Online</span>
													) : (
														<span className="badge badge-primary">Offline</span>
													)}
												</td>
												<td>
													₹<span style={{ fontWeight: 'bold' }}>{value?.amount}</span> <br />
													{value?.offlinePaymentMode && (
														<small>Mode: {value?.offlinePaymentMode}</small>
													)}
												</td>
												<td>
													{new Date(value?.paymentDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>{value?.paymentRef}</td>
												<td>
													<ReceiptPDF data={value?._id} />
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
